import * as Yup from 'yup';
import { validatePassword } from '../../../utils/auth';

export default Yup.object({
  currentPassword: Yup.string()
    .nullable()
    .required('schemas:password-form.currentPassword.required'),
  newPassword: Yup.string()
    .nullable()
    .test(
      'validate-password',
      'schemas:password-form.newPassword.characters',
      function validPassword(value) {
        const newPasswordReference = this.resolve(Yup.ref('confirmPassword'));
        if (value === undefined && newPasswordReference === undefined)
          return true;
        return validatePassword(value, {
          minLength: 8,
          oneDigit: true,
          oneUpper: true
        });
      }
    )
    .required('schemas:password-form.newPassword.required'),
  confirmPassword: Yup.string()
    .nullable()
    .test(
      'validate-confirm-password',
      'schemas:password-form.confirmPassword.characters',
      function validConfirm(value) {
        const newPasswordReference = this.resolve(Yup.ref('newPassword'));
        if (value === undefined && newPasswordReference === undefined)
          return true;
        return validatePassword(value, {
          minLength: 8,
          oneDigit: true,
          oneUpper: true
        });
      }
    )
    .oneOf(
      [Yup.ref('newPassword'), null],
      'schemas:password-form.confirmPassword.matchError'
    )
    .required('schemas:password-form.confirmPassword.required')
});
